import '/opt/actions-runner/_work/crate/crate/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "tiny9": "entrypoint-c6d4bb33-tiny9-WXUgJq",
  "wideGridContainer": "entrypoint-c6d4bb33-wideGridContainer-WXUgJq",
  "wideOffset2": "entrypoint-c6d4bb33-wideOffset2-WXUgJq",
  "wideOffset9": "entrypoint-c6d4bb33-wideOffset9-WXUgJq",
  "confinedOffset5": "entrypoint-c6d4bb33-confinedOffset5-WXUgJq",
  "default1": "entrypoint-c6d4bb33-default1-WXUgJq",
  "xwide12": "entrypoint-c6d4bb33-xwide12-WXUgJq",
  "confinedOffset2": "entrypoint-c6d4bb33-confinedOffset2-WXUgJq",
  "xwide2": "entrypoint-c6d4bb33-xwide2-WXUgJq",
  "tiny7": "entrypoint-c6d4bb33-tiny7-WXUgJq",
  "defaultOffset6": "entrypoint-c6d4bb33-defaultOffset6-WXUgJq",
  "tinyOffset6": "entrypoint-c6d4bb33-tinyOffset6-WXUgJq",
  "wideOffset5": "entrypoint-c6d4bb33-wideOffset5-WXUgJq",
  "defaultOffset2": "entrypoint-c6d4bb33-defaultOffset2-WXUgJq",
  "tinyOffset5": "entrypoint-c6d4bb33-tinyOffset5-WXUgJq",
  "tinyOffset3": "entrypoint-c6d4bb33-tinyOffset3-WXUgJq",
  "xwide3": "entrypoint-c6d4bb33-xwide3-WXUgJq",
  "default2": "entrypoint-c6d4bb33-default2-WXUgJq",
  "wide3": "entrypoint-c6d4bb33-wide3-WXUgJq",
  "xwide11": "entrypoint-c6d4bb33-xwide11-WXUgJq",
  "tiny11": "entrypoint-c6d4bb33-tiny11-WXUgJq",
  "xwide4": "entrypoint-c6d4bb33-xwide4-WXUgJq",
  "xwideOffset2": "entrypoint-c6d4bb33-xwideOffset2-WXUgJq",
  "confinedOffset6": "entrypoint-c6d4bb33-confinedOffset6-WXUgJq",
  "tiny6": "entrypoint-c6d4bb33-tiny6-WXUgJq",
  "defaultOffset5": "entrypoint-c6d4bb33-defaultOffset5-WXUgJq",
  "confinedOffset4": "entrypoint-c6d4bb33-confinedOffset4-WXUgJq",
  "wide0": "entrypoint-c6d4bb33-wide0-WXUgJq",
  "tiny12": "entrypoint-c6d4bb33-tiny12-WXUgJq",
  "tinyOffset7": "entrypoint-c6d4bb33-tinyOffset7-WXUgJq",
  "wideOffset4": "entrypoint-c6d4bb33-wideOffset4-WXUgJq",
  "wideOffset8": "entrypoint-c6d4bb33-wideOffset8-WXUgJq",
  "defaultOffset3": "entrypoint-c6d4bb33-defaultOffset3-WXUgJq",
  "tiny4": "entrypoint-c6d4bb33-tiny4-WXUgJq",
  "confined12": "entrypoint-c6d4bb33-confined12-WXUgJq",
  "xwide9": "entrypoint-c6d4bb33-xwide9-WXUgJq",
  "xwideOffset7": "entrypoint-c6d4bb33-xwideOffset7-WXUgJq",
  "default11": "entrypoint-c6d4bb33-default11-WXUgJq",
  "tiny0": "entrypoint-c6d4bb33-tiny0-WXUgJq",
  "confinedOffset11": "entrypoint-c6d4bb33-confinedOffset11-WXUgJq",
  "xwideOffset10": "entrypoint-c6d4bb33-xwideOffset10-WXUgJq",
  "confined10": "entrypoint-c6d4bb33-confined10-WXUgJq",
  "wide9": "entrypoint-c6d4bb33-wide9-WXUgJq",
  "default12": "entrypoint-c6d4bb33-default12-WXUgJq",
  "col": "entrypoint-c6d4bb33-col-WXUgJq",
  "gridContainer": "entrypoint-c6d4bb33-gridContainer-WXUgJq",
  "confinedOffset3": "entrypoint-c6d4bb33-confinedOffset3-WXUgJq",
  "xwide0": "entrypoint-c6d4bb33-xwide0-WXUgJq",
  "tiny8": "entrypoint-c6d4bb33-tiny8-WXUgJq",
  "grid": "entrypoint-c6d4bb33-grid-WXUgJq",
  "defaultOffset7": "entrypoint-c6d4bb33-defaultOffset7-WXUgJq",
  "tinyOffset4": "entrypoint-c6d4bb33-tinyOffset4-WXUgJq",
  "tinyOffset8": "entrypoint-c6d4bb33-tinyOffset8-WXUgJq",
  "confinedOffset7": "entrypoint-c6d4bb33-confinedOffset7-WXUgJq",
  "wide7": "entrypoint-c6d4bb33-wide7-WXUgJq",
  "wide11": "entrypoint-c6d4bb33-wide11-WXUgJq",
  "confinedOffset10": "entrypoint-c6d4bb33-confinedOffset10-WXUgJq",
  "xwide7": "entrypoint-c6d4bb33-xwide7-WXUgJq",
  "confined2": "entrypoint-c6d4bb33-confined2-WXUgJq",
  "default7": "entrypoint-c6d4bb33-default7-WXUgJq",
  "wideOffset0": "entrypoint-c6d4bb33-wideOffset0-WXUgJq",
  "xwide5": "entrypoint-c6d4bb33-xwide5-WXUgJq",
  "default4": "entrypoint-c6d4bb33-default4-WXUgJq",
  "confined3": "entrypoint-c6d4bb33-confined3-WXUgJq",
  "wide12": "entrypoint-c6d4bb33-wide12-WXUgJq",
  "default3": "entrypoint-c6d4bb33-default3-WXUgJq",
  "default5": "entrypoint-c6d4bb33-default5-WXUgJq",
  "confined4": "entrypoint-c6d4bb33-confined4-WXUgJq",
  "confined1": "entrypoint-c6d4bb33-confined1-WXUgJq",
  "xwide8": "entrypoint-c6d4bb33-xwide8-WXUgJq",
  "xwideOffset3": "entrypoint-c6d4bb33-xwideOffset3-WXUgJq",
  "defaultOffset9": "entrypoint-c6d4bb33-defaultOffset9-WXUgJq",
  "xwideOffset8": "entrypoint-c6d4bb33-xwideOffset8-WXUgJq",
  "wide10": "entrypoint-c6d4bb33-wide10-WXUgJq",
  "wide5": "entrypoint-c6d4bb33-wide5-WXUgJq",
  "defaultOffset11": "entrypoint-c6d4bb33-defaultOffset11-WXUgJq",
  "defaultOffset1": "entrypoint-c6d4bb33-defaultOffset1-WXUgJq",
  "xwideOffset9": "entrypoint-c6d4bb33-xwideOffset9-WXUgJq",
  "defaultOffset10": "entrypoint-c6d4bb33-defaultOffset10-WXUgJq",
  "xwide1": "entrypoint-c6d4bb33-xwide1-WXUgJq",
  "wide2": "entrypoint-c6d4bb33-wide2-WXUgJq",
  "confinedOffset9": "entrypoint-c6d4bb33-confinedOffset9-WXUgJq",
  "xwideOffset6": "entrypoint-c6d4bb33-xwideOffset6-WXUgJq",
  "tinyOffset2": "entrypoint-c6d4bb33-tinyOffset2-WXUgJq",
  "tiny10": "entrypoint-c6d4bb33-tiny10-WXUgJq",
  "wide4": "entrypoint-c6d4bb33-wide4-WXUgJq",
  "default0": "entrypoint-c6d4bb33-default0-WXUgJq",
  "tiny2": "entrypoint-c6d4bb33-tiny2-WXUgJq",
  "confinedOffset1": "entrypoint-c6d4bb33-confinedOffset1-WXUgJq",
  "defaultOffset8": "entrypoint-c6d4bb33-defaultOffset8-WXUgJq",
  "wideOffset3": "entrypoint-c6d4bb33-wideOffset3-WXUgJq",
  "wide8": "entrypoint-c6d4bb33-wide8-WXUgJq",
  "wideOffset1": "entrypoint-c6d4bb33-wideOffset1-WXUgJq",
  "tiny3": "entrypoint-c6d4bb33-tiny3-WXUgJq",
  "wideOffset10": "entrypoint-c6d4bb33-wideOffset10-WXUgJq",
  "xwideOffset4": "entrypoint-c6d4bb33-xwideOffset4-WXUgJq",
  "confined0": "entrypoint-c6d4bb33-confined0-WXUgJq",
  "default9": "entrypoint-c6d4bb33-default9-WXUgJq",
  "confined6": "entrypoint-c6d4bb33-confined6-WXUgJq",
  "confined8": "entrypoint-c6d4bb33-confined8-WXUgJq",
  "confined9": "entrypoint-c6d4bb33-confined9-WXUgJq",
  "default10": "entrypoint-c6d4bb33-default10-WXUgJq",
  "tiny5": "entrypoint-c6d4bb33-tiny5-WXUgJq",
  "wideOffset6": "entrypoint-c6d4bb33-wideOffset6-WXUgJq",
  "wideOffset11": "entrypoint-c6d4bb33-wideOffset11-WXUgJq",
  "xwideOffset0": "entrypoint-c6d4bb33-xwideOffset0-WXUgJq",
  "wide1": "entrypoint-c6d4bb33-wide1-WXUgJq",
  "confined7": "entrypoint-c6d4bb33-confined7-WXUgJq",
  "confined11": "entrypoint-c6d4bb33-confined11-WXUgJq",
  "tinyOffset9": "entrypoint-c6d4bb33-tinyOffset9-WXUgJq",
  "xwideOffset5": "entrypoint-c6d4bb33-xwideOffset5-WXUgJq",
  "standardGridContainer": "entrypoint-c6d4bb33-standardGridContainer-WXUgJq",
  "confinedOffset8": "entrypoint-c6d4bb33-confinedOffset8-WXUgJq",
  "xwide10": "entrypoint-c6d4bb33-xwide10-WXUgJq",
  "default6": "entrypoint-c6d4bb33-default6-WXUgJq",
  "tinyOffset1": "entrypoint-c6d4bb33-tinyOffset1-WXUgJq",
  "confined5": "entrypoint-c6d4bb33-confined5-WXUgJq",
  "armstrongGridContainer": "entrypoint-c6d4bb33-armstrongGridContainer-WXUgJq",
  "confinedOffset0": "entrypoint-c6d4bb33-confinedOffset0-WXUgJq",
  "xwide6": "entrypoint-c6d4bb33-xwide6-WXUgJq",
  "default8": "entrypoint-c6d4bb33-default8-WXUgJq",
  "tiny1": "entrypoint-c6d4bb33-tiny1-WXUgJq",
  "xwideOffset1": "entrypoint-c6d4bb33-xwideOffset1-WXUgJq",
  "xwideOffset11": "entrypoint-c6d4bb33-xwideOffset11-WXUgJq",
  "row": "entrypoint-c6d4bb33-row-WXUgJq",
  "tinyOffset11": "entrypoint-c6d4bb33-tinyOffset11-WXUgJq",
  "wideOffset7": "entrypoint-c6d4bb33-wideOffset7-WXUgJq",
  "defaultOffset4": "entrypoint-c6d4bb33-defaultOffset4-WXUgJq",
  "tinyOffset10": "entrypoint-c6d4bb33-tinyOffset10-WXUgJq",
  "wide6": "entrypoint-c6d4bb33-wide6-WXUgJq",
  "tinyOffset0": "entrypoint-c6d4bb33-tinyOffset0-WXUgJq"
};